import { client, createURL } from './client';

export function getPlayer() {
  return client.get(createURL('/api/player'));
}

export function syncProfile(profile) {
  return client.post(createURL('/api/player/sync-profile'), profile);
}

export function getCategories() {
  return client.get(createURL('/api/categories'));
}

export function getCategoryWords(id) {
  return client.get(createURL(`/api/categories/${id}/words`));
}

export function getWord(id) {
  return client.get(createURL(`/api/words/${id}`));
}

export function getDailyWords() {
  return client.get(createURL('/api/daily-words'));
}

export function replaceDailyWord(id) {
  return client.post(createURL(`/api/daily-words/${id}/replace`));
}

export function getDictionary() {
  return client.get(createURL('/api/dictionary'));
}

export function addDictionaryWord(id) {
  return client.post(createURL(`/api/dictionary/${id}`));
}

export function deleteDictionaryWord(id) {
  return client.delete(createURL(`/api/dictionary/${id}`));
}

export function getDictionaryStatus(id) {
  return client.get(createURL(`/api/dictionary/${id}/status`));
}

export function getTraining(payload) {
  return client.post(createURL('/api/training'), payload);
}

export function completeTraining(correctWordIDs) {
  return client.post(createURL('/api/progress/training-complete'), {
    correct_word_ids: correctWordIDs
  });
}

export function getRating() {
  return client.get(createURL('/api/rating'));
}

export function getAchievements() {
  return client.get(createURL('/api/achievements'));
}

export function checkAchievements(targetObject, targetType) {
  return client.post(createURL('/api/achievements/check'), {
    target_object: targetObject,
    target_type: targetType
  });
}
